import config from "../config";
import {getCountryService, ICountryService} from "../services/country/country-service";
import styles from './outfit-image.scss'

export class CutoutImage extends HTMLElement {
  /** The Product Id */
  productId: string;
  /** The Variant Id */
  variantId: string;
  /** The resolution quality e.g. 'low', 'mid', 'high' 'higher', 'full-hd' */
  private resolution: string;
  /** The imageKey itself*/
  private imageKey: string;

  private cs: ICountryService;

  /** Holds an internal state of whether the element was initialized before */
  private isInitialized: boolean;


  constructor() {
    super();

    this.cs = getCountryService();
    this.setCutout = this.setCutout.bind(this);
  }

  connectedCallback() {
    if (this.isInitialized) {return}
    this.resolution = this.getAttribute('resolution') || this.resolution;
    this.productId = this.getAttribute('product-id') || this.productId;
    this.variantId = this.getAttribute('variant-id') || this.variantId;

    this.innerHTML = `<style>${styles}</style>`
    this.isInitialized = true;
  }

  getMapKey() {
    return `${this.productId}-${this.variantId}`
  }

  relativeUrlWithCountryCode(path: string) {
    const countryCode = this.cs.getCountryCodeFromLocation();
    if (countryCode === 'de') {
      return path;
    }
    return `/${countryCode}${path}`
  }

  setCutout(key: string) {
    if (!key) {
      return;
    }

    this.imageKey = key;
  }

  renderCutoutImage() {
    this.innerHTML = `
    <style>${styles}</style>
    <a href="${this.relativeUrlWithCountryCode(`/products/detail/${this.productId}/${this.variantId}`)}">
        <img class="loading"
             src="${config.specialsApiUrl}/csp/images/image/public/${this.imageKey}?res=low&frame=1_1"
             alt="outfit-image"
             sizes="(min-width: 1024px) 1200px, (max-width: 768px) 400px"
             srcset="${config.specialsApiUrl}/csp/images/image/public/${this.imageKey}?res=${this.resolution || 'mid' } 1200w,
                     ${config.specialsApiUrl}/csp/images/image/public/${this.imageKey}?res=mid 400w">
    </a>`;
    this.querySelector('img').addEventListener("load", this.onImageLoaded.bind(this));
  }

  onImageLoaded(e: Event) {
    const image = e.target as HTMLImageElement;
    image.removeEventListener("load", this.onImageLoaded);
    image.classList.remove("loading");
  }
}

window.customElements.define('cutout-image', CutoutImage);
